import { createSelector } from '@ngrx/store';

export const getSourceCodeLoading = createSelector(
  (state: any) => state['projectSourceCode']?.isUpsertProcessLoading,
  (state: any) => state['projectSourceCode']?.isDeleteProcessLoading,
  (isUpsertProcessLoading: boolean,
    isDeleteProcessLoading: boolean,
  ) => isUpsertProcessLoading || isDeleteProcessLoading
);
